import express, { Router } from 'express';

import userAuthAndCheckPermissions from '@/modules/auth/auth.user.middleware';
import { validateMiddleware } from '@/shared/utils/middlewares/index';
import * as unitBookingOrHoldController from '@/modules/activity/unitBookingOrHold/unitBookingOrHold.controller';
import * as unitValidation from '@/modules/project/unit/unit.validation';

const router: Router = express.Router();

router
  .route('/:unitId/held-by')
  .get(
    userAuthAndCheckPermissions(),
    validateMiddleware(unitValidation.getUnitHeldBy),
    unitBookingOrHoldController.getLatestHoldByUnitId,
  );

export default router;
